export const enrollSection = {
  background: "url(/enrollImages/enrollDuga.svg)",
  backgroundRepeat: "no-repeat	",
  width: "100%",
  backgroundSize: "100%, 100%",
};

export const enrollTitle = {
  color: "#CA0088",
  textAlign: "center",
  fontWeight: "700",
  fontSize: "34px",
  fontFamily: "AppRegular",
};

export const enrollText = {
  color: "#D8D8D8",
  fontWeight: "500",
  fontSize: "18px",
  fontFamily: "AppRegular",
  textAlign: "center",
  width: "80%",
  paddingLeft: "10%",
};

export const chooseEnrolText = {
  color: "#1D4CF2",
  textAlign: "center",
  fontWeight: "600",
  fontSize: "20px",
  fontFamily: "AppRegular",
};
